import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export default function BookingQueueDisplay() {
  const { center } = useParams();
  const [data, setData] = useState({ tokens: [], summary: {} });
  const [nextGuest, setNextGuest] = useState(null);
  const token = localStorage.getItem("session_token") || "";

  useEffect(() => {
    const load = async () => {
      try {
        const [q, n] = await Promise.all([
          fetch(`${API}/api/booking-tokens/live-queue`, {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token, center }),
          }).then((r) => r.json()),
          fetch(`${API}/api/booking-tokens/recommended-next`, {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token, center }),
          }).then((r) => r.json()),
        ]);
        setData(q);
        setNextGuest(n.next);
      } catch { /* silent */ }
    };
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [center, token]);

  const called = data.tokens?.find((t) => t.status === "called") ||
                 data.tokens?.find((t) => t.status === "table_assigned");

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#3a0000] via-[#8B0000] to-[#3a0000] text-white p-8" data-testid="queue-display-page">
      <div className="max-w-7xl mx-auto space-y-6">
        <div className="flex items-center justify-between border-b border-white/20 pb-4">
          <div className="flex items-center gap-3">
            <div className="w-16 h-16 rounded-full bg-white text-[#8B0000] flex items-center justify-center font-bold text-3xl">P</div>
            <div>
              <p className="text-3xl font-bold">Purnabramha</p>
              <p className="text-lg opacity-80">{center} · Live Queue</p>
            </div>
          </div>
          <p className="text-2xl">{new Date().toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}</p>
        </div>

        {/* NOW SERVING */}
        {called ? (
          <div className="bg-white/10 backdrop-blur-sm border-2 border-white/30 rounded-2xl p-12 text-center" data-testid="now-serving-card">
            <p className="text-2xl uppercase tracking-widest opacity-80">Now Serving</p>
            <p className="text-9xl font-bold my-4 text-yellow-300" data-testid="now-serving-token">{called.token_number}</p>
            <p className="text-3xl">Please proceed to</p>
            <p className="text-7xl font-bold my-4 text-emerald-300" data-testid="now-serving-table">Table {called.table_number || "—"}</p>
            <p className="text-xl opacity-80 mt-4">{called.guest_name} · {called.total_pax} pax</p>
          </div>
        ) : (
          <div className="bg-white/5 border border-white/20 rounded-2xl p-12 text-center">
            <p className="text-3xl opacity-70">No table ready yet</p>
            <p className="text-lg opacity-50 mt-2">Please wait — our team will call you shortly.</p>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Waiting queue */}
          <div className="bg-white/5 border border-white/20 rounded-xl p-6">
            <p className="text-xl uppercase tracking-widest opacity-80 mb-3">Waiting Queue</p>
            <div className="space-y-2" data-testid="queue-display-waiting">
              {(data.tokens || []).filter((t) => t.status === "waiting").slice(0, 8).map((t) => (
                <div key={t.token_number} className="flex items-center justify-between bg-white/10 rounded-lg px-4 py-2">
                  <span className="text-2xl font-bold text-yellow-200">{t.token_number}</span>
                  <span>{t.guest_name}</span>
                  <span className="opacity-70">{t.total_pax} pax · {t.waiting_minutes || 0}m</span>
                </div>
              ))}
              {(data.tokens || []).filter((t) => t.status === "waiting").length === 0 && (
                <p className="opacity-60 text-center py-4">No one waiting right now.</p>
              )}
            </div>
          </div>
          {/* Stats */}
          <div className="bg-white/5 border border-white/20 rounded-xl p-6">
            <p className="text-xl uppercase tracking-widest opacity-80 mb-3">Live Snapshot</p>
            <div className="grid grid-cols-2 gap-3 text-lg">
              <div><p className="opacity-70 text-sm">Waiting</p><p className="text-3xl font-bold">{data.summary?.currently_waiting || 0}</p></div>
              <div><p className="opacity-70 text-sm">Seated</p><p className="text-3xl font-bold">{data.summary?.guests_seated || 0}</p></div>
              <div><p className="opacity-70 text-sm">Tables Free</p><p className="text-3xl font-bold">{data.summary?.tables_available || 0}</p></div>
              <div><p className="opacity-70 text-sm">Avg Wait</p><p className="text-3xl font-bold">{data.summary?.avg_wait_min || 0}m</p></div>
            </div>
            {nextGuest && (
              <div className="mt-4 bg-yellow-500/20 border border-yellow-400/40 rounded-lg p-3">
                <p className="text-xs uppercase opacity-80">Suggested Next</p>
                <p className="text-2xl font-bold">{nextGuest.token_number} · {nextGuest.guest_name}</p>
                <p className="opacity-70">Waiting {nextGuest.wait_min} min</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
